const fetchJson = async(URI) => {
  try {
    const response = await fetch(URI);
    if (response.status !== 200) return null;
    return response.json();
  } catch (e) {
    return null;
  }
};

export default fetchJson;
